class CollectionFilters extends HTMLElement {
  constructor() {
    super();
    
    this.body = document.body;
    this.categoryButtons = this.querySelectorAll('.collection-filters__button');
    this.tagButtons = this.querySelectorAll('.collection-filters__tag');
    this.applyButtons = this.querySelectorAll('.collection-filters__apply');
    this.sortButtons = this.querySelectorAll('.collection-filters__sort');

    this.mobileFilterContainer = this.querySelector('.collection-filters__categories-wrapper');
    this.mobileSortContainer = this.querySelector('.collection-filters__sorting');
    
    this.collectionURL = this.dataset.collectionUrl;
    this.currentTags = this.dataset.currentTags.split('+');
    this.temporaryTags = this.currentTags.slice();
    this.sortBy = this.dataset.currentSort;

    this.setListeners();
  }

  setListeners() {
    // Handle Button/Category Click
    this.categoryButtons.forEach(categoryButton => {
      categoryButton.addEventListener('click', this.handleButtonClick.bind(this, categoryButton));
    });

    // Handle Filter Click
    this.tagButtons.forEach(tagButton => {
      tagButton.addEventListener('click', this.handleFilterClick.bind(this, tagButton));
    });

    // Apply filters close dropdown
    this.applyButtons.forEach(applyButton => {
      applyButton.addEventListener('click', () => {
        if (window.innerWidth < 769) {
          document.querySelector('.collection-filters__categories.active').classList.remove('active');
        }
      });
    });

    // Handle Sort Click
    this.sortButtons.forEach(sortButton => {
      sortButton.addEventListener('click', this.handleSortClick.bind(this, sortButton));
    });

    // Mobile Filter Open
    this.querySelector('.open-filters').addEventListener('click', () => {
      this.openMobileFilters();
    });

    // Mobile Sort Open
    if(this.querySelector('.open-sort')){
      this.querySelector('.open-sort').addEventListener('click', () => {
      this.openMobileSort();
    });
    }
  }

  handleButtonClick(categoryButton, event) {
    const parent = event.currentTarget.parentElement;
    const dropdown = event.currentTarget.nextElementSibling;
    const activeCategories = document.querySelectorAll('.collection-filters__item.active');

    // Toggle dropdowns
    if (parent.classList.contains('active')) {
      parent.classList.remove('active');
      slideUp(dropdown);
    } else {
      if (activeCategories.length > 0) {
        activeCategories.forEach(activeCategory => {
          const dropdown = activeCategory.querySelector('.collection-filters__dropdown');
          activeCategory.classList.remove('active');
          slideUp(dropdown);
        });
      }
      parent.classList.add('active');
      slideDown(dropdown);
    }
  }

  openMobileFilters() {
    const closeFilterContainer = document.querySelector('.collection-filters__close');

    this.mobileFilterContainer.classList.add('active');
    this.body.classList.add('collection-filters--open');
    closeFilterContainer.addEventListener('click', () => {
      this.closeMobileFilters();
    });
  }

  closeMobileFilters() {
    this.body.classList.remove('collection-filters--open');
    this.mobileFilterContainer.classList.remove('active');
  }

  openMobileSort() {
    const closeSortContainer = document.querySelector('.collection-filters__sort-close');

    this.mobileSortContainer.classList.add('active');
    closeSortContainer.addEventListener('click', () => {
      this.closeMobileSort();
    });
  }

  closeMobileSort() {
    this.mobileSortContainer.classList.remove('active');
  }

  handleFilterClick(tagButton, event) {
    const filter = tagButton.dataset.value;
    const parent = tagButton.closest('.collection-filters__item');
    const activeSiblings = parent.querySelectorAll('.collection-filters__tag.active');

    if (tagButton.classList.contains('active')) {
       // Delete the tag if already active
      this.temporaryTags.splice(this.temporaryTags.indexOf(filter), 1);

      if (activeSiblings.length < 2) {
        parent.classList.remove('has-filter');
      }
    } else {

      // Add if not previously active
      this.temporaryTags.push(filter);
      parent.classList.add('has-filter');
    }

    this.updateActiveButtons();
    this.applyFilters();
  }

  handleButtonClickPlp() { 
    const subscribe_buttons = document.querySelectorAll('.js-subscribe-button');
    if( !subscribe_buttons ) return;
    subscribe_buttons.forEach( button => {
      button.addEventListener('click', (e) => {
        const triggerID = `modal-${button.dataset.section}`;
        if (triggerID) {
          MicroModal.show(triggerID);
        }
      });
    })
  }

  updateActiveButtons() {
    this.tagButtons.forEach(tagButton => {
      const filter = tagButton.dataset.value;

      if (this.temporaryTags.includes(filter)) {
        tagButton.classList.add('active');
      } else {
        tagButton.classList.remove('active');
      }
    });
  }

  applyFilters() {
    // Only reload sections if tags have changed
    this.currentTags = this.currentTags.filter(el => el != '');
    this.temporaryTags = this.temporaryTags.filter(el => el != '');
    if (this.currentTags.sort().join(',') !== this.temporaryTags.sort().join(',')) {
      this.currentTags = this.temporaryTags.slice();
      this.reloadSections();
    }
  }

  removeTag(tag) {
    this.temporaryTags.splice(this.temporaryTags.indexOf(tag), 1);

    this.updateActiveButtons();
    this.applyFilters();
  }

  handleSortClick(sortButton) {
    const sort = sortButton.dataset.value;

    // Make clicked button active
    if (!sortButton.classList.contains('active')) {
      this.querySelector('.collection-filters__sort.active').classList.remove('active');
      sortButton.classList.add('active');

      this.sortBy = sort;

      this.currentTags = this.currentTags.filter(el => el != '');
      this.reloadSections();
    }
  }

  reloadSections() {
    // Change URL
    const tags = this.currentTags.length > 0 ?  '/' + this.currentTags.join('+') : '';
    const newUrl = window.location.protocol + '//' + window.location.host + this.collectionURL + tags + '?sort_by=' + this.sortBy;
    
    if (history.replaceState) {
      window.history.pushState({ path: newUrl }, '', newUrl);
    }

    // Get section rendering URL 
    const url = newUrl + `/?section_id=main-collection-product-grid`;

    // Fetch and replace sections
    this.enableLoading();
    fetch(location.pathname + '?sort_by=' + this.sortBy)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;

        this.getSectionsToRender().forEach((section => {
            const sectionEl = document.getElementById(section.id);
            if( !sectionEl ) return;
            sectionEl.innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById(section.id).innerHTML;
        }));
      
        this.handleButtonClickPlp();
        this.disableLoading();
      })
      .catch(() => {
        this.disableLoading();
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'ProductGridContainer'
      },
      {
        id: 'CollectionFilterActiveTags'
      },
      {
        id: 'CollectionFilterProductTotal'
      }
    ]
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading() {
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
  }

  disableLoading() {
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.remove('loading');
  }
}

customElements.define('collection-filters', CollectionFilters);